module.exports = __webpack_public_path__ + "img/product-preview-61.de2061e.png";